export default function ProgressBar({ progress, isActive = false }) {
  return (
    <div className="line-progress-container">
      <div className="line-progress">
        <div 
          className={`line-progress-fill ${isActive ? 'active' : ''}`} 
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="line-progress-text">{Math.round(progress)}%</span>
    </div>
  );
}
